import { useState } from "react";
import { Box, Paper, Typography, useMediaQuery, useTheme } from "@mui/material";
import ChatIcon from '@mui/icons-material/Chat';
import Templete from "../../template/Template";
import ChatListaConversas from "../../components/Chat/ChatListaConversas";
import ChatJanela from "../../components/Chat/ChatJanela";
import ModalGrupoChat from "../../components/Chat/ModalGrupoChat";
import { useChat } from "../../components/Chat/ChatProvider";

// Conteudo separado: precisa estar DENTRO do Template para consumir o ChatProvider
function ChatConteudo() {
    const { habilitado, conversaAtiva, conversaAtivaId, abrirConversa } = useChat();
    const theme = useTheme();
    const telaPequena = useMediaQuery(theme.breakpoints.down('md'));

    const [openGrupo, setOpenGrupo] = useState(false);
    const [editandoGrupo, setEditandoGrupo] = useState(false);

    if (!habilitado) {
        return (
            <Paper elevation={1} sx={{ p: 4, textAlign: 'center' }}>
                <Typography sx={{ fontSize: 14, color: '#757575' }}>
                    Você não tem permissão para usar o chat interno.
                </Typography>
            </Paper>
        );
    }

    const mostrarLista = !telaPequena || !conversaAtivaId;
    const mostrarJanela = !telaPequena || Boolean(conversaAtivaId);

    return (
        <>
            <Paper elevation={1} sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 90px)', overflow: 'hidden' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1, borderBottom: '1px solid #e0e0e0' }}>
                    <ChatIcon color="primary" />
                    <Typography variant="h6" component="h1" sx={{ fontWeight: 'bold' }}>
                        Chat Interno
                    </Typography>
                </Box>

                <Box sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
                    {mostrarLista && (
                        <Box sx={{ width: telaPequena ? '100%' : 320, flexShrink: 0, borderRight: '1px solid #e0e0e0', minHeight: 0 }}>
                            <ChatListaConversas
                                onNovoGrupo={() => {
                                    setEditandoGrupo(false);
                                    setOpenGrupo(true);
                                }}
                            />
                        </Box>
                    )}
                    {mostrarJanela && (
                        <ChatJanela
                            onVoltar={telaPequena ? () => abrirConversa(null) : undefined}
                            onEditarGrupo={() => {
                                setEditandoGrupo(true);
                                setOpenGrupo(true);
                            }}
                        />
                    )}
                </Box>
            </Paper>

            <ModalGrupoChat
                open={openGrupo}
                setOpen={setOpenGrupo}
                grupo={editandoGrupo ? conversaAtiva : null}
            />
        </>
    );
}

export default function Chat() {
    return (
        <Templete menuActive="chat">
            <ChatConteudo />
        </Templete>
    );
}
